export const createNamespacesRequests = (client) => ({
    listNamespaces: async (params) => {
        const { data, meta, links } = await client.api.get("namespaces", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map